import * as R from 'ramda'
import Vue from 'vue'
import Router from 'vue-router'
import NedbView from './views/Nedb.vue'
import WorkerView from './views/Worker.vue'
import ResultView from './views/Result.vue'
import PrintView from './views/Print.vue'
import DissatisfyView from './views/Dissatisfy.vue'

import store from './store.js';

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Nedb',
      component: NedbView,
    },
    {
      path: '/worker',
      name: 'Worker',
      component: WorkerView
    },
    {
      path: '/print',
      name: 'Print',
      component: PrintView
    },
    {
      path: '/dissatisfy',
      name: 'Dissatisfy',
      component: DissatisfyView
    },
    {
      path: '/result',
      name: 'Result',
      component: ResultView,
      beforeEnter: (to, from, next) => {
        if (R.isEmpty(store.state.resultJson)) {
          next('/')
        } else {
          next()
        }
      }
    }
  ]
})
